import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/filter/box-open.svg'


const _withScopeId = n => (_pushScopeId("data-v-0c5f919c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row d-flex flex-column p-1 gap-5" }
const _hoisted_2 = { class: "col-12 d-flex justify-content-between align-items-center p-0" }
const _hoisted_3 = { class: "d-flex gap-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content","font-size":"22px"},
  class: "m-0 fas fa-arrow-left"
}, null, -1))
const _hoisted_5 = {
  class: "lista_atendimentos card p-0",
  style: {"font-size":"17px","overflow-x":"scroll"}
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<li class=\"header_list d-flex col-12 p-4\" style=\"height:fit-content;\" data-v-0c5f919c><span class=\"col-2 d-flex justify-content-center subtitulo\" data-v-0c5f919c>PLACA/ID ATEND.</span><span class=\"col-2 d-flex justify-content-center subtitulo\" data-v-0c5f919c>STATUS</span><span class=\"col-2 d-flex justify-content-center subtitulo\" data-v-0c5f919c>VEICULO</span><span class=\"col-2 d-flex justify-content-center subtitulo\" data-v-0c5f919c>LOJA</span><span class=\"col-2 d-flex justify-content-center subtitulo\" data-v-0c5f919c>DATA/HORA</span><span class=\"col-2 d-flex justify-content-center subtitulo\" data-v-0c5f919c>INFO</span></li>", 1)
const _hoisted_7 = {
  key: 0,
  class: "card d-flex h-100 justify-content-center",
  id: "empty"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"color":"rgb(213 202 202)"} }, "Sem atendimentos", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "m-5",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "col-2 d-flex align-items-center flex-column justify-content-center gap-3" }
const _hoisted_12 = { class: "col-2 d-flex align-items-center flex-column justify-content-center gap-3" }
const _hoisted_13 = { class: "col-2 d-flex align-items-center justify-content-center" }
const _hoisted_14 = { class: "col-2 d-flex align-items-center flex-column justify-content-center gap-3" }
const _hoisted_15 = { class: "col-2 d-flex align-items-center flex-column justify-content-center gap-3" }
const _hoisted_16 = { class: "col-2 d-flex align-items-center justify-content-center" }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "col-2 d-flex align-items-center flex-column justify-content-center gap-3" }
const _hoisted_19 = {
  style: {"font-weight":"bold","font-size":"20px","width":"70%"},
  class: "m-0 p-0 cor_texto_1 texto-bold text-center border border-secondary rounded-1 bg-white"
}
const _hoisted_20 = { class: "m-0 p-0 cor_texto_1 texto-bold text-center" }
const _hoisted_21 = { class: "col-2 d-flex align-items-center flex-column gap-3" }
const _hoisted_22 = { class: "m-0 p-0 cor_texto_1 texto-bold text-center" }
const _hoisted_23 = {
  key: 0,
  class: "m-0 p-0 cor_texto_1 rounded-1 texto-bold text-center",
  style: {"background":"rgb(38 236 176)","width":"80%"}
}
const _hoisted_24 = {
  key: 1,
  class: "m-0 p-0 cor_texto_1 rounded-1 texto-bold text-center",
  style: {"background":"rgb(38 236 176)","width":"80%"}
}
const _hoisted_25 = {
  key: 2,
  class: "m-0 p-0 cor_texto_1 rounded-1 texto-bold text-center bg-light-danger",
  style: {"width":"80%"}
}
const _hoisted_26 = {
  key: 3,
  class: "m-0 p-0 cor_texto_1 texto-bold text-center"
}
const _hoisted_27 = { class: "col-2 d-flex justify-content-center" }
const _hoisted_28 = {
  style: {"white-space":"nowrap"},
  class: "texto cor_texto_1 d-inline-block text-truncate text-wrap"
}
const _hoisted_29 = {
  key: 0,
  class: "col-2 d-flex flex-column justify-content-center ps-2"
}
const _hoisted_30 = ["title"]
const _hoisted_31 = ["title"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto bold cor_texto_1" }, "Resp:", -1))
const _hoisted_33 = {
  style: {"white-space":"nowrap"},
  class: "texto cor_texto_1 d-inline-block text-truncate"
}
const _hoisted_34 = {
  key: 1,
  class: "col-2 d-flex flex-column justify-content-center ps-2"
}
const _hoisted_35 = {
  style: {"white-space":"nowrap"},
  class: "texto bold cor_texto_1 d-inline-block text-truncate"
}
const _hoisted_36 = { class: "d-flex align-content-center gap-2" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto bold cor_texto_1" }, "Resp:", -1))
const _hoisted_38 = {
  style: {"white-space":"nowrap"},
  class: "texto cor_texto_1 d-inline-block text-truncate"
}
const _hoisted_39 = { class: "col-2 d-flex align-items-center flex-column justify-content-center gap-3" }
const _hoisted_40 = {
  style: {"white-space":"nowrap"},
  class: "m-0 p-0 texto cor_texto_1 d-inline-block text-truncate"
}
const _hoisted_41 = {
  style: {"white-space":"nowrap"},
  class: "m-0 p-0 texto cor_texto_1 d-inline-block text-truncate"
}
const _hoisted_42 = { class: "col-2 d-flex justify-content-center" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "1.25rem",
  height: "1.25rem",
  viewBox: "0 0 8 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.931763 16.5714H1.71301V10.9286H0.931763C0.500278 10.9286 0.150513 10.5788 0.150513 10.1473V8.28125C0.150513 7.84977 0.500278 7.5 0.931763 7.5H5.30676C5.73825 7.5 6.08801 7.84977 6.08801 8.28125V16.5714H6.86926C7.30075 16.5714 7.65051 16.9212 7.65051 17.3527V19.2188C7.65051 19.6502 7.30075 20 6.86926 20H0.931763C0.500278 20 0.150513 19.6502 0.150513 19.2188V17.3527C0.150513 16.9212 0.500278 16.5714 0.931763 16.5714ZM3.90051 0C2.34719 0 1.08801 1.25918 1.08801 2.8125C1.08801 4.36582 2.34719 5.625 3.90051 5.625C5.45383 5.625 6.71301 4.36582 6.71301 2.8125C6.71301 1.25918 5.45379 0 3.90051 0Z",
    fill: "#ED2B46"
  })
], -1))
const _hoisted_45 = [
  _hoisted_44
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ElSkeletonItem = _resolveComponent("ElSkeletonItem")!
  const _component_ElSkeleton = _resolveComponent("ElSkeleton")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (_ctx.storeId)
        ? (_openBlock(), _createBlock(_component_Title, { key: 0 }, {
            default: _withCtx(() => [
              _createTextVNode(" Atendimentos " + _toDisplayString(_ctx.nomeConcessionaria && _ctx.nomeConcessionaria), 1)
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_Title, { key: 1 }, {
            default: _withCtx(() => [
              _createTextVNode("Atendimentos " + _toDisplayString(_ctx.lojaFixada && _ctx.lojaFixada.nomeFantasia), 1)
            ]),
            _: 1
          })),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          clearable: "",
          placeholder: "Filtre por placa, veículo ou responsável",
          modelValue: _ctx.fastFind,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fastFind) = $event)),
          onKeyup: _withKeys(_ctx.enviar, ["enter"])
        }, null, 8, ["modelValue", "onKeyup"]),
        _createVNode(_component_Button, {
          type: "button",
          text: "Voltar",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.history.back()))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("ul", _hoisted_5, [
      _hoisted_6,
      (_ctx.attendanceFinded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
        : _createCommentVNode("", true),
      (_ctx.skeleton)
        ? (_openBlock(), _createBlock(_component_ElSkeleton, {
            key: 1,
            class: "d-flex w-100 flex-column bg-white",
            style: {"border-radius":"0 0 10px 10px"},
            loading: true,
            animated: ""
          }, {
            template: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (n) => {
                return _createElementVNode("div", {
                  key: 'sk-' + n,
                  class: "d-flex align-items-center p-5 border-bottom"
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_ElSkeletonItem, {
                      variant: "text",
                      style: {"width":"70%","height":"30px"}
                    }),
                    _createVNode(_component_ElSkeletonItem, {
                      variant: "text",
                      style: {"width":"70%","height":"30px"}
                    })
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_ElSkeletonItem, {
                      variant: "text",
                      style: {"width":"80%","height":"30px"}
                    }),
                    _createVNode(_component_ElSkeletonItem, {
                      variant: "text",
                      style: {"width":"80%","height":"30px"}
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_ElSkeletonItem, {
                      variant: "text",
                      style: {"width":"80%","height":"30px"}
                    })
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_ElSkeletonItem, {
                      variant: "text",
                      style: {"width":"80%","height":"30px"}
                    }),
                    _createVNode(_component_ElSkeletonItem, {
                      variant: "text",
                      style: {"width":"80%","height":"30px"}
                    })
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_ElSkeletonItem, {
                      variant: "text",
                      style: {"width":"80%","height":"30px"}
                    }),
                    _createVNode(_component_ElSkeletonItem, {
                      variant: "text",
                      style: {"width":"80%","height":"30px"}
                    })
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_ElSkeletonItem, {
                      variant: "rect",
                      style: {"width":"4rem","height":"3rem","border-radius":"4px"}
                    })
                  ])
                ])
              }), 64))
            ]),
            _: 1
          }))
        : (!_ctx.skeleton && !_ctx.attendanceFinded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attendanceArray, (attendance, key) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: key,
                  style: {"height":"fit-content","border-radius":"10px","min-width":"930px"},
                  class: "atendimentoUnico card d-flex flex-row col-12 p-5 align-items-center"
                }, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("p", _hoisted_19, _toDisplayString(attendance.placa ? attendance.placa.toUpperCase() : "000-0000"), 1),
                    _createElementVNode("p", _hoisted_20, " ID: " + _toDisplayString(attendance.id), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("p", _hoisted_22, _toDisplayString(attendance.status || '-'), 1),
                    (attendance.pago === '1')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_23, " Pago "))
                      : (attendance.statusIntegracao === 'transmitido')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_24, " Transmitido "))
                        : (attendance.statusIntegracao === 'naoTransmitido')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_25, " Não Transmitido "))
                          : (!attendance.statusIntegracao)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_26, "-"))
                            : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("p", _hoisted_28, _toDisplayString(attendance.veiculo || "-"), 1)
                  ]),
                  (!_ctx.storeSelected)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("p", {
                          style: {"white-space":"nowrap"},
                          class: "texto bold cor_texto_1 d-inline-block text-truncate",
                          title: attendance.nomeFantasia || '-'
                        }, _toDisplayString(attendance.nomeFantasia || "-"), 9, _hoisted_30),
                        _createElementVNode("div", {
                          class: "d-flex align-content-center gap-2",
                          title: attendance.responsavel || '-'
                        }, [
                          _hoisted_32,
                          _createElementVNode("span", _hoisted_33, _toDisplayString(attendance.responsavel || "-"), 1)
                        ], 8, _hoisted_31)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.storeSelected.nome || "-"), 1),
                        _createElementVNode("div", _hoisted_36, [
                          _hoisted_37,
                          _createElementVNode("span", _hoisted_38, _toDisplayString(attendance.responsavel || "-"), 1)
                        ])
                      ])),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("p", _hoisted_40, _toDisplayString(new Date(attendance.created_at).toLocaleDateString("pt-BR")), 1),
                    _createElementVNode("p", _hoisted_41, _toDisplayString(new Date(attendance.created_at).toLocaleString("pt-BR", {
                  hour: "numeric",
                  minute: "numeric",
                  hour12: false,
                })) + " hrs ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.redirectToAttendanceDetails(attendance.id)),
                      class: "btn btn-light-danger d-flex flex-row gap-4",
                      id: "infoAtd"
                    }, _hoisted_45, 8, _hoisted_43)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_component_Pagination, {
      ref: "atendimentoPaginationRef",
      key: _ctx.route.path,
      arr: _ctx.attendanceArray,
      totalBanco: _ctx.total,
      onPageChanged: _ctx.handlePageChange,
      tipo: 'Atendimentos encontrados'
    }, null, 8, ["arr", "totalBanco", "onPageChanged"]))
  ]))
}